export const SET_LICENSE_PLATE_BLACKLIST = 'SET_LICENSE_PLATE_BLACKLIST';
